<!--卡片图表-->
<template>
  <div id="card-wrap">
    <div
      v-if="false"
      class="card-wrap"
      :style="{
        'background': config.background,
        'border-radius': config.isRadio ? '5px' : 0,
        fontFamily:config.fontFamily?config.fontFamily:'auto',
      }"
    >
      <div
        class="card-header"
        :style="{
          'color': config.title.color,
          'height': config.title.height + 'px',
          'lineHeight': config.title.lineHeight + 'px',
          'fontSize': config.title.fontSize + 'px',
        }"
      >
        {{ config.title.text }}
      </div>
      <div
        class="card-box"
        :style="{
          'marginTop': config.content.offsetY + 'px',
          'textAlign': config.content.position
        }"
      >
        <span
          class="number"
          :style="{
            'color': config.content.color,
            'fontSize': config.content.fontSize + 'px',
            'lineHeight': config.content.fontSize + 'px',
            'marginLeft': config.content.offsetX + 'px'
          }"
        >{{ getContentMoney() }}</span>
        <span
          class="company"
          :style="{
            'fontSize': config.content.fontSize + 'px',
            'lineHeight': config.content.fontSize + 'px'
          }"
        >{{ config.content.company }}</span>
      </div>
      <div
        class="progress-item"
        v-if="config.outputMatch.visible"
        :style="{
          marginLeft: config.outputMatch.offsetX + 'px',
          marginTop: config.outputMatch.offsetY + 'px',
        }"
      >
        <span
          :style="{
            'color': config.outputMatch.color,
            'fontSize': config.outputMatch.fontSize + 'px',
            'minWidth': config.outputMatch.minWidth + 'px'
          }"
        >{{ config.outputMatch.text }}</span>
        <Progress
          class="progressVal"
          :dw="config.outputMatch.percentage"
          :visible-num="config.outputMatch.numVisible"
          :num="getOutputValue"
          :config="config"
        ></Progress>
      <!--<el-progress :text-inside="true" :stroke-width="18" :percentage="getOutputValue"></el-progress>-->
      </div>
      <div
        class="progress-item"
        v-if="config.monthMatch.visible"
        :style="{
          marginLeft: config.monthMatch.offsetX + 'px',
          marginTop: config.monthMatch.offsetY + 'px'
        }"
      >
        <span
          :style="{
            'color': config.monthMatch.color,
            'fontSize': config.monthMatch.fontSize + 'px',
            'minWidth': config.monthMatch.minWidth + 'px'
          }"
        >
          {{ config.monthMatch.text }}
        </span>
        <img
          class="img"
          v-if="showImg"
          src="@/assets/images/card-rise.png"
          alt=""
        />
        <img
          class="img"
          v-if="!showImg"
          src="@/assets/images/card-floor.png"
          alt=""
        />
        <span class="pre-value">{{ getMonthMatch + '%' }}</span>
      </div>
    </div>
    <div
      v-else
      class="card-wrap card-mode-1"
      :style="{
        'background': config.background,
        'border-radius': config.isRadio ? '5px' : 0
      }"
    >
      <div
        class="card-header"
        v-if="config.title.show"
        :style="{
          'color': config.title.color,
          'height': config.title.height + 'px',
          'lineHeight': config.title.lineHeight + 'px',
          'fontSize': config.title.fontSize + 'px',
        }"
      >
        {{ config.title.text }}
        <el-tooltip
          class="item"
          effect="dark"
          :content="config.title.titleContentInfo"
          placement="top-start"
          v-if="config.title.titleContentInfo&&config.title.titleContentInfo!==''"
        >
          <i class="el-icon-info"></i>
        </el-tooltip>
      </div>
      <div
        class="car-box-wrap"
        v-for="(item,index) in this.chartData"
        :key="index"
        :style="{
          marginBottom:config.content.marginBottomItem + 'px'
        }"
      >
        <div
          class="card-box"
          :style="{
            'marginBottom': config.content.offsetY + 'px',
            'display': config.content.fontSize ==0?'none':'flex',
          }"
        >
          <span
            v-if="config.content.mode === 'top'"
            class="subTitle"
            :style="{
              'color': config.outputMatch.color,
              'fontSize': config.outputMatch.fontSize + 'px',
              'width': config.outputMatch.minWidth + 'px',
              'text-align': config.outputMatch.textAlign
            }"
          >{{ getValueTitle(item) }}</span>
          <span
            class="number-wrap"
            :style="{
              'textAlign': config.content.position,
              'lineHeight': config.content.fontSize + 'px',
            }"
          >
            <span
              class="number"
              :style="{
                'color': config.content.color,
                'fontSize': config.content.fontSize + 'px',
                'lineHeight': config.content.fontSize + 'px',
                'marginLeft': config.content.offsetX + 'px'
              }"
            >{{ getContentMoney(item) }}</span>
            <span
              class="company"
              :style="{'fontSize': config.content.fontSize + 'px'}"
            >{{ config.content.company }}</span>
          </span>
        </div>
        <div
          class="progress-item"
          v-if="config.outputMatch.visible"
          :style="{
            marginLeft: config.outputMatch.offsetX + 'px',
            marginTop: config.outputMatch.offsetY + 'px',
          }"
        >
          <span
            class="subTitle"
            v-if="config.content.mode === 'bot'"
            :style="{
              'color': config.outputMatch.color,
              'fontSize': config.outputMatch.fontSize + 'px',
              'width': config.outputMatch.minWidth + 'px',
              'text-align': config.outputMatch.textAlign
            }"
          >{{ getValueTitle(item) }}</span>
          <Progress
            class="progressVal"
            :dw="config.outputMatch.percentage"
            :visible-num="config.outputMatch.numVisible"
            :num="getOutputValue(item)"
            :config="config"
          ></Progress>
        </div>
        <div
          class="progress-item"
          v-if="config.monthMatch.visible"
          :style="{
            marginLeft: config.monthMatch.offsetX + 'px',
            marginTop: config.monthMatch.offsetY + 'px'
          }"
        >
          <span
            :style="{
              'color': config.monthMatch.color,
              'fontSize': config.monthMatch.fontSize + 'px',
              'minWidth': config.monthMatch.minWidth + 'px'
            }"
          >
            {{ config.monthMatch.text }}
          </span>
          <img
            class="img"
            v-if="showImg(item)"
            src="@/assets/images/card-rise.png"
            alt=""
          />
          <img
            class="img"
            v-if="!showImg(item)"
            src="@/assets/images/card-floor.png"
            alt=""
          />
          <span class="pre-value">{{ getMonthMatch(item) + '%' }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Progress from '../Progress'
export default {
  name: 'Card',
  props: {
    config: {
      type: [Object, Array],
      default: () => {
        return {}
      }
    },
    chartData: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      max: 0
    }
  },
  computed: {
    // getOutputValue () {
    //   return this.chartData[0][this.config['yField']]
    // },
    // getMonthMatch () {
    //   return this.chartData[0][this.config['seriesField']]
    // },
    // showImg () {
    //   return this.getMonthMatch >= 0
    // }
  },
  methods: {
    showImg (item) {
      return this.getMonthMatch(item) >= 0
    },
    getMonthMatch (item) {
      return item[this.config['seriesField']]
    },
    getOutputValue (item) {
      if (this.config['outputMatch'].isPercent) {
        return item[this.config['yField']]
      } else {
        this.max = Math.max(...this.chartData.map(i => i[this.config['xField']]))
        return (item[this.config['xField']] / this.max * 100).toFixed(2)
      }
    },
    getValueTitle (item) {
      return item[this.config['titleField']]
    },
    getContentMoney (item) {
      let str = item[this.config['xField']]
      if (this.config.content['thousandthPercent']) {
        if (str.toString().split('.')[1]) {
          str = this.format_number(str.toString().split('.')[0]) + '.' + str.toString().split('.')[1]
        } else {
          str = this.format_number(str.toString().split('.')[0])
        }
      }
      return str
    },
    format_number (n) {
      n = n.toString()
      var len = n.length
      if (len <= 3) { return n }
      var r = len % 3
      const start = n.slice(0, r)
      const end = n.slice(r).match(/\d{3}/g).join(',')
      return r > 0 ? start + ',' + end : end
    }
  },
  components: {
    Progress
  },
  watch: {
    'config.content.thousandthPercent': {
      handler () {
        this.getContentMoney()
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus" scoped>
.card-wrap
  width 100%
  height 100%
  box-sizing border-box
  .card-header
    height 24px
    line-height 24px
    padding 0 0 10px 0
    color #FFFFFF
  .card-box
    // padding-bottom 10px
    .company
      color #ffffffcc
  .progress-item
    display flex
    align-items center
    .img
      margin 0 5px
    .progressVal
      flex 1
      // margin-left 5px
    >>>.el-progress-bar__innerText
      margin -2px 5px 0 5px
    .pre-value
      font-size 14px
      color #ffffffcc
#card-wrap
  width 100%
  height 100%
  .card-mode-1
    .card-box
      display flex
      align-items center
      .number-wrap
        flex-grow 1
        display inline-block
        .number
          display: inline-block;
          overflow: hidden;
        .number
          vertical-align top
  .car-box-wrap
    .subTitle
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
  .card-wrap
    *
      line-height: inherit
</style>
